import { useLocation } from "react-router-dom";
import $ from "jquery";
import { Link } from "react-router-dom";
// import { hasPermission } from "../../../utils/commonfunction";
import logo from "../../../../src/assets/admin/img/logos/logo.png";
import { useTranslation } from "react-i18next";

const SideBar = () => {
  const loc = useLocation();
  const { t } = useTranslation();

  const toggleDropdown = (e) => {
    e.preventDefault();
    const dropDown = e.target.parentElement;
    if (dropDown.classList.contains("show")) {
      dropDown.classList.remove("show");
    } else {
      dropDown.classList.add("show");
    }
  };

  const hoverSidebar = (e) => {
    if ($("body").hasClass("main-sidebar-hide")) {
      $("body").addClass("main-sidebar-open");
    } else {
      $("body").removeClass("main-sidebar-open");
    }
  };

  const removeHoverSidebar = (e) => {
    $("body").removeClass("main-sidebar-open");
  };

  return (
    <div
      className="main-sidebar main-sidebar-sticky side-menu ps ps--active-y"
      id="app_sidebar"
      onMouseEnter={hoverSidebar}
      onMouseLeave={removeHoverSidebar}
    >
      <div className="sidemenu-logo">
        <a className="main-logo" href="/admin/dashboard">
          <img
            src={logo}
            className="header-brand-img icon-logo admin-logo"
            alt="logo"
            style={{ height: "1.6rem" }}
            id="logo_short"
          />
          <img
            src={logo}
            className="header-brand-img desktop-logo admin-logo rounded"
            style={{ height: "2.3rem" }}
            alt="logo"
            id="logo_full"
          />
        </a>
      </div>
      {/* Dashboard section start */}
      <div className="main-sidebar-body">
        <ul className="nav">
          <li
            className={
              "nav-item" +
              (loc.pathname === "/admin/dashboard" ? " active" : "")
            }
          >
            <Link className="nav-link" to="/admin/dashboard">
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-home sidemenu-icon"></i>
              <span className="sidemenu-label">
                {t("sidebar_link_dashboard")}
              </span>
            </Link>
          </li>
          {/* Dashboard section end */}
          <li
            className={
              "nav-item" +
              (loc.pathname.includes("/admin/analysis") ? " active" : "")
            }
          >
            <Link className="nav-link" to="/admin/analysis">
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-chart-line sidemenu-icon"></i>
              <span className="sidemenu-label">{t("Analysis")}</span>
            </Link>
          </li>

          {/* User section start */}
          <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/admin/user-management")
                ? "show active"
                : "")
            }
          >
            <Link className="nav-link" to="/admin/user-management/user/list/1">
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-user-tie sidemenu-icon"></i>
              <span className="sidemenu-label">{t("Users")}</span>
            </Link>
          </li>

          <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/admin/game-management")
                ? "show active"
                : "")
            }
          >
            <Link className="nav-link" to="/admin/game-management/game/list/1">
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-gamepad sidemenu-icon"></i>
              <span className="sidemenu-label">{t("Games")}</span>
            </Link>
          </li>

          {/* <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/admin/reward-management")
                ? "show active"
                : "")
            }
          >
            <Link
              className="nav-link"
              to="/admin/reward-management/reward-config/list/1"
            >
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-gift sidemenu-icon"></i>
              <span className="sidemenu-label">{t("Rewards")}</span>
            </Link>
          </li> */}

          {/* Transaction section start */}

          {/* <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/payable-transaction") || loc.pathname.includes("/payout-transaction")
                ? "show active"
                : "")
            }
          >
            <a
              className="nav-link with-sub submenu"
              onClick={toggleDropdown}
              href={"/"}
            >
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-money-bill-wave sidemenu-icon"></i>
              <span className="sidemenu-label">{t("Transaction")}</span>
              <i className="angle fe fe-chevron-right"></i>
            </a>
            <ul className="nav-sub">
              <li
                className={`nav-sub-item ${loc.pathname.includes("/payable-transaction") ? "active" : ""
                  }`}
              >
                <Link
                  className="nav-sub-link"
                  to={`/admin/payable-transaction/list/1`}
                >
                  Payable transaction
                </Link>
              </li>
              <li
                className={`nav-sub-item ${loc.pathname.includes("/payout-transaction") ? "active" : ""
                  }`}
              >
                <Link
                  className="nav-sub-link"
                  to={`/admin/payout-transaction/list/1`}
                >
                  Payout Transaction
                </Link>
              </li>
            </ul>
          </li> */}

          {/* Transaction section end */}

          {/* Cms section start */}
          {/* {hasPermission("/admin/cms") ? ( */}
          <li
            className={
              `nav-item ` + (loc.pathname.includes("/cms") ? "show active" : "")
            }
          >
            <a
              className="nav-link with-sub submenu"
              onClick={toggleDropdown}
              href={"/"}
            >
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-edit sidemenu-icon"></i>
              <span className="sidemenu-label">{t("sidebar_link_cms")}</span>
              <i className="angle fe fe-chevron-right"></i>
            </a>
            <ul className="nav-sub">
              <li
                className={`nav-sub-item ${loc.pathname.includes("/cms/pages") ? " active" : ""
                  }`}
              >
                <Link
                  className="nav-sub-link"
                  to={`/admin/cms/pages/list/${1}`}
                >
                  {t("sidebar_link_pages")}
                </Link>
              </li>
              <li
                className={`nav-sub-item ${loc.pathname.includes("/cms/faq") ? " active" : ""
                  }`}
              >
                <Link className="nav-sub-link" to={`/admin/cms/faq/list/${1}`}>
                  FAQ
                </Link>
              </li>
              <li
                className={
                  "nav-sub-item" +
                  (loc.pathname.includes("/cms/default-email-template")
                    ? " active"
                    : "")
                }
              >
                <Link
                  className="nav-sub-link"
                  to={`/admin/cms/default-email-template/list/${1}`}
                >
                  {t("sidebar_link_email_template")}
                </Link>
              </li>

              <li
                className={
                  "nav-sub-item" +
                  (loc.pathname.includes("/cms/settings") ? " active" : "")
                }
              >
                <Link className="nav-sub-link" to={`/admin/cms/settings`}>
                  {t("sidebar_link_global_settings")}
                </Link>
              </li>
            </ul>
          </li>
          {/* // ) : null} */}
          {/* Cms section end */}

          {/* subscription section start */}

          <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/subscription") ? "show active" : "")
            }
          >
            <a
              className="nav-link with-sub submenu"
              onClick={toggleDropdown}
              href={"/"}
            >
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-credit-card sidemenu-icon"></i>
              <span className="sidemenu-label">
                {t("sidebar_link_subscription")}
              </span>
              <i className="angle fe fe-chevron-right"></i>
            </a>
            <ul className="nav-sub">
              {/* <li
                className={`nav-sub-item ${
                  loc.pathname.includes("/subscription/subscription-feature")
                    ? " active"
                    : ""
                }`}
              >
                <Link
                  className="nav-sub-link"
                  to={`subscription/subscription-feature`}
                >
                  Subscription Features
                </Link>
              </li>
              <li
                className={`nav-sub-item ${
                  loc.pathname.includes("/subscription/subscription-benefit")
                    ? " active"
                    : ""
                }`}
              >
                <Link
                  className="nav-sub-link"
                  to={`subscription/subscription-benefit`}
                >
                  Subscription Benefits
                </Link>
              </li> */}
              <li
                className={`nav-sub-item ${loc.pathname.includes("/subscription/subscription-plan")
                  ? " active"
                  : ""
                  }`}
              >
                <Link
                  className="nav-sub-link"
                  to={`subscription/subscription-plan/list/1`}
                >
                  Subscription Plan
                </Link>
              </li>
              <li
                className={`nav-sub-item ${loc.pathname.includes("/subscription/transaction")
                  ? " active"
                  : ""
                  }`}
              >
                <Link
                  className="nav-sub-link"
                  to={`subscription/transaction/list/1`}
                >
                  Transaction
                </Link>
              </li>
              <li
                className={`nav-sub-item ${loc.pathname.includes("/subscription/payment-transactions")
                  ? " active"
                  : ""
                  }`}
              >
                <Link
                  className="nav-sub-link"
                  to={`subscription/payment-transactions/list/1`}
                >
                  Payment Transactions
                </Link>
              </li>
              <li
                className={`nav-sub-item ${loc.pathname.includes("/subscription/failed-transactions")
                  ? " active"
                  : ""
                  }`}
              >
                <Link
                  className="nav-sub-link"
                  to={`subscription/failed-transactions/list/1`}
                >
                  Failed Transactions
                </Link>
              </li>
              <li
                className={`nav-sub-item ${loc.pathname.includes("/subscription/manual-recovery")
                  ? " active"
                  : ""
                  }`}
              >
                <Link
                  className="nav-sub-link"
                  to={`subscription/manual-recovery`}
                >
                  Manual Recovery
                </Link>
              </li>
            </ul>
          </li>

          {/* subscription section end */}

          {/*  Contact Us section  */}
          <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/contact-us") ? "show active" : "")
            }
          >
            <Link className="nav-link" to={`/admin/contact-us/list/${1}`}>
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fas fa-address-card sidemenu-icon"></i>
              <span className="sidemenu-label">
                {t("sidebar_link_contact_us")}
              </span>
            </Link>
          </li>
          {/*  Contact Us section end */}

          <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/notification") ? "show active" : "")
            }
          >
            <Link className="nav-link" to={`/admin/notification/list/${1}`}>
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-bell sidemenu-icon"></i>
              <span className="sidemenu-label">{t("Notifications")}</span>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SideBar;
